import { useState } from 'react';
import BookParticipationModal from 'src/components/BookParticipationModal';

export default function ViewAvailabilityModal({ ...props }) {
	const [open, setOpen] = useState(false);
	return <BookParticipationModal open={open} setOpen={setOpen} {...props} />;
}
